import { isEmpty } from 'lodash-es';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { useLocalStorage } from '@frontend/web-storage';

const LOCALSTORAGE_KEY = 'weave.scheduler-v3-ui-ff-override';

export const useScheduleV3Override = () => {
  const [isSchedulerV3FFOverride] = useLocalStorage({
    key: LOCALSTORAGE_KEY,
    // Note: need to keep it like this as for initial cases, we receive false even if value is set to true
    defaultValue: localStorage.getItem(LOCALSTORAGE_KEY) === 'true',
  });

  return { isSchedulerV3FFOverride: !!isSchedulerV3FFOverride };
};

export const useGetWSMActiveLocationIds = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { getCustomizationFlagLocationMap } = useAppFlagStore();

  const wsmActiveLocationIds = Object.entries(
    getCustomizationFlagLocationMap({ locationIds: selectedLocationIds, flagName: 'weaveschedulemanagement' })
  )
    .filter(([, flag]) => flag?.state === 'ACTIVE')
    .map(([locationId]) => locationId);

  return { wsmActiveLocationIds };
};

export const useGetSchedulerV3FeatureFlagDetails = () => {
  const { isSchedulerV3FFOverride } = useScheduleV3Override();
  const { featureFlags } = useAppFlagStore();
  const isFeatureFlagsLoaded = !isEmpty(featureFlags);

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  const hasSchedulerV3UI = getFeatureFlagValue('scheduler-v3-ui', 'ALL');

  const isLoading = isLoadingIntegrationDetails || !isFeatureFlagsLoaded;

  const isV3Enabled = hasSchedulerV3UI || isSchedulerV3FFOverride || !isIntegratedOffice;
  return {
    isScheduleV3FlagEnabled: isLoading ? false : isV3Enabled,
    isSchedulerV2FlagEnabled: isLoading ? false : !isV3Enabled,
    isLoading: isLoadingIntegrationDetails || !isFeatureFlagsLoaded,
  };
};
